import { Role } from '@guiker/permissions'

import { LeaseRoleNames } from '../../entity'
import { LeaseActions } from '../lease-actions'

export const GuarantorRole: Role = {
  name: LeaseRoleNames.GUARANTOR,
  permissions: [{ action: LeaseActions.SignLeaseAsGuarantor }, { action: LeaseActions.ViewLease }],
}
